// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3UqBd","notes":"Notes_notes__5Qn69"};